// components/exercises/lesson/UnsupportedExercise.tsx
import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { ExerciseDefinition } from "utils/exercises/types";

interface UnsupportedExerciseProps {
  exercise: ExerciseDefinition;
}

const UnsupportedExercise: React.FC<UnsupportedExerciseProps> = ({
  exercise,
}) => {
  return (
    <Box textAlign="center" p="4">
      <Text fontSize="xl" color="red.500">
        Unsupported Exercise Type
      </Text>
      <Text fontSize="lg" mt="2">
        The exercise type "{exercise.type}" is currently not supported in this
        training session.
      </Text>
      <Text mt="2">
        Please contact support or try a different type of exercise.
      </Text>
    </Box>
  );
};

export default UnsupportedExercise;
